import React, { Component } from "react";
import { Helmet } from "react-helmet";

import Cover from "../components/Cover";
import Intro from "../components/Intro";

export default class Home extends Component {
  constructor(props) {
    super(props)
    this.meta = {}
    this.meta.canonical = 'https://zuri.co.uk' + props.location.pathname
    this.meta.description = 'Zuri beauty, we offer a wide range of beauty treatments, located in dalry road edinburgh'
    console.log('Home',props)
  }
  render() {
    console.log('Home',this.props)
    return (
      <main>
        <Helmet>
          <title>Home</title>
          <meta name="description" content={this.meta.description} />
          <link rel="canonical" href={this.meta.canonical}></link>
        </Helmet>
        <Cover/>
        <Intro/>
      </main>
    );
  }
}